import { render, staticRenderFns } from "./SPIFProfileCashTables.vue?vue&type=template&id=687204f6"
import script from "./SPIFProfileCashTables.vue?vue&type=script&lang=js"
export * from "./SPIFProfileCashTables.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfileCashTables.vue?vue&type=style&index=0&id=687204f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports